import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationType, SocketEvents, SubtaskStatus } from '@core/enums';
import { untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { FetchProfileImageDirective } from '@shared/directives';
import { CourseTask, TaskEntity } from '@core/entities';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TasksComposition } from '@shared/compositions';
import { BadgeComponent, IconComponent } from '@shared/components/ui';

@Component({
  selector: 'app-course-task',
  imports: [CommonModule, BadgeComponent, IconComponent, TranslateModule, FetchProfileImageDirective, NgxSkeletonLoaderModule],
  templateUrl: './course-task.component.html',
  styleUrls: ['./course-task.component.scss'],
})
export class CourseTaskComponent extends TasksComposition implements OnInit {
  @Input() task: TaskEntity | CourseTask;
  @Input() taskId: number;
  protected readonly SubtaskStatus = SubtaskStatus;

  ngOnInit(): void {
    this._fetchTaskDetails();

    this._socketService
      .fromEvent(SocketEvents.GetNotification)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data: NotificationType) => {
          if (data === NotificationType.Task) {
            this._fetchTaskDetails();
          }
        },
      });
  }

  private _fetchTaskDetails() {
    if (this.task && this.task.id) {
      this.currentTask = this.task as TaskEntity;
      this._fetchTask(this.task.id);
    } else if (this.taskId) {
      this._fetchTask(this.taskId);
    }
  }

  private _fetchTask(id: number) {
    this._fetchTaskByIdReturnPromise(id).then((res) => {
      this.currentTask = res;
      this._fetchCourseTaskCollaborators();
    });
  }
}
